import React from 'react';

import { Routes, Route } from 'react-router-dom';

import AccountingDashboard from './AccountingDashboard';

import GenericModulePage from './GenericModulePage';

import UserAccessManagement from './UserAccess/UserAccessManagement';

import ChartOfAccounts from './GeneralLedger/ChartOfAccounts';

import JournalEntries from './GeneralLedger/JournalEntries';

import AccountingPeriods from './GeneralLedger/AccountingPeriods';

import MultiCurrency from './GeneralLedger/MultiCurrency';

import CostCenters from './GeneralLedger/CostCenters';

import VendorsManagement from './AccountsPayable/VendorsManagement';

import BillsManagement from './AccountsPayable/BillsManagement';

import PurchaseOrders from './AccountsPayable/PurchaseOrders';

import BankAccountsPage from './BankCash/BankAccountsPage';

import BankReconciliation from './BankCash/BankReconciliation';

import CashFlowPage from './BankCash/CashFlowPage';

import ARDashboard from './AccountsReceivable/ARDashboard';

import FixedAssetsPage from './FixedAssets/FixedAssetsPage';

import TaxRatesPage from './Tax/TaxRatesPage';

import FinancialReportsPage from './Reporting/FinancialReportsPage';

import BudgetsPage from './Budgeting/BudgetsPage';

import CompanySettingsPage from './SystemAdmin/CompanySettingsPage';



const AccountingRoutes = () => (

  <Routes>

    <Route index element={<AccountingDashboard />} />

    <Route path="dashboard" element={<AccountingDashboard />} />



    <Route path="user-access" element={<UserAccessManagement />} />

    <Route path="user-access/*" element={<UserAccessManagement />} />



    <Route path="general-ledger" element={<GenericModulePage moduleId="general-ledger" />} />

    <Route path="general-ledger/chart-of-accounts" element={<ChartOfAccounts />} />

    <Route path="general-ledger/journal-entries" element={<JournalEntries />} />

    <Route path="general-ledger/periods" element={<AccountingPeriods />} />

    <Route path="general-ledger/currency" element={<MultiCurrency />} />

    <Route path="general-ledger/cost-centers" element={<CostCenters />} />



    <Route path="accounts-receivable" element={<ARDashboard />} />

    <Route path="accounts-receivable/aging" element={<FinancialReportsPage />} />



    <Route path="accounts-payable" element={<GenericModulePage moduleId="accounts-payable" />} />

    <Route path="accounts-payable/vendors" element={<VendorsManagement />} />

    <Route path="accounts-payable/bills" element={<BillsManagement />} />

    <Route path="accounts-payable/purchase-orders" element={<PurchaseOrders />} />

    <Route path="accounts-payable/aging" element={<FinancialReportsPage />} />



    <Route path="bank-cash" element={<GenericModulePage moduleId="bank-cash" />} />

    <Route path="bank-cash/accounts" element={<BankAccountsPage />} />

    <Route path="bank-cash/transactions" element={<BankAccountsPage />} />

    <Route path="bank-cash/reconciliation" element={<BankReconciliation />} />

    <Route path="bank-cash/cash-flow" element={<CashFlowPage />} />

    <Route path="bank-cash/petty-cash" element={<BankAccountsPage />} />



    <Route path="inventory" element={<GenericModulePage moduleId="inventory" />} />

    <Route path="inventory/*" element={<GenericModulePage moduleId="inventory" />} />



    <Route path="fixed-assets" element={<GenericModulePage moduleId="fixed-assets" />} />

    <Route path="fixed-assets/register" element={<FixedAssetsPage />} />

    <Route path="fixed-assets/depreciation" element={<FixedAssetsPage />} />

    <Route path="fixed-assets/disposal" element={<FixedAssetsPage />} />

    <Route path="fixed-assets/maintenance" element={<FixedAssetsPage />} />



    <Route path="tax" element={<GenericModulePage moduleId="tax" />} />

    <Route path="tax/rates" element={<TaxRatesPage />} />

    <Route path="tax/codes" element={<TaxRatesPage />} />

    <Route path="tax/reports" element={<FinancialReportsPage />} />

    <Route path="tax/jurisdictions" element={<TaxRatesPage />} />



    <Route path="reporting" element={<GenericModulePage moduleId="reporting" />} />

    <Route path="reporting/financial" element={<FinancialReportsPage />} />

    <Route path="reporting/trial-balance" element={<FinancialReportsPage />} />

    <Route path="reporting/profit-loss" element={<FinancialReportsPage />} />

    <Route path="reporting/balance-sheet" element={<FinancialReportsPage />} />



    <Route path="budgeting" element={<GenericModulePage moduleId="budgeting" />} />

    <Route path="budgeting/budgets" element={<BudgetsPage />} />

    <Route path="budgeting/variance" element={<BudgetsPage />} />

    <Route path="budgeting/forecasting" element={<BudgetsPage />} />

    <Route path="budgeting/scenarios" element={<BudgetsPage />} />



    <Route path="communications" element={<GenericModulePage moduleId="communications" />} />

    <Route path="communications/notifications" element={<CompanySettingsPage />} />

    <Route path="communications/email" element={<CompanySettingsPage />} />

    <Route path="communications/documents" element={<GenericModulePage moduleId="communications" />} />



    <Route path="integrations" element={<GenericModulePage moduleId="integrations" />} />

    <Route path="integrations/*" element={<GenericModulePage moduleId="integrations" />} />



    <Route path="system-admin" element={<GenericModulePage moduleId="system-admin" />} />

    <Route path="system-admin/company" element={<CompanySettingsPage />} />

    <Route path="system-admin/backup" element={<GenericModulePage moduleId="system-admin" />} />

    <Route path="system-admin/logs" element={<UserAccessManagement />} />



    <Route path="security" element={<GenericModulePage moduleId="security" />} />

    <Route path="security/compliance" element={<UserAccessManagement />} />

    <Route path="security/privacy" element={<CompanySettingsPage />} />

    <Route path="security/recovery" element={<GenericModulePage moduleId="security" />} />



    <Route path="mobile" element={<GenericModulePage moduleId="mobile" />} />

    <Route path="mobile/*" element={<GenericModulePage moduleId="mobile" />} />



    <Route path="advanced" element={<GenericModulePage moduleId="advanced" />} />

    <Route path="advanced/*" element={<GenericModulePage moduleId="advanced" />} />

  </Routes>

);



export default AccountingRoutes;

